"use strict";

angular.module("customer")
.service("RegistrationService", function(
    $rootScope, $state, $stateParams, $http, gettextCatalog, FlashBag, UserService, appConfig
) {
    this.fillUserWithTokenInvitationInfo = function(token) {
        var user = {
            Token: token,
            departments: []
        };

        if (user.Token && $stateParams.retailer) {
            $http({
                method: "GET",
                url: appConfig.API_SERVER + "/auth/customer/information/",
                params: {
                    Token: user.Token,
                    RetailerID: $stateParams.retailer,
                    vendor_id: $stateParams.stocks || $stateParams.vendor,
                    catalog_id: $stateParams.catalog
                }
            }).then(function onSuccess(response) {
                if (!response.data) {
                    var msg = gettextCatalog.getString("Cannot find your retailer information.");
                    FlashBag.preformattedError(msg);
                    user.Token = "";
                }
                else {
                    user = angular.extend(user, response.data);

                    if (response.data.errorToken) {
                        var msgToken = gettextCatalog.getString("Your token is invalid.");
                        FlashBag.preformattedError(msgToken);
                        user.Token = "";
                    }

                    if (response.data.userExists) {
                        if ($stateParams.stocks) {
                            UserService.logoutAndRedirect("login", {
                                vendor: $stateParams.stocks,
                                catalog: $stateParams.catalog
                            });
                        }
                        else if ($stateParams.vendor) {
                            UserService.logoutAndRedirect("login", {
                                vendor: $stateParams.vendor
                            });
                        }
                        else if ($stateParams.product) {
                            UserService.logoutAndRedirect("login", {
                                product: $stateParams.product
                            });
                        }
                        else if ($stateParams.invoice) {
                            UserService.logoutAndRedirect("login", {
                                invoice: $stateParams.invoice
                            });
                        }
                        else if ($stateParams.payment) {
                            UserService.logoutAndRedirect("login", {
                                payment: $stateParams.payment
                            });
                        }
                        else if ($stateParams.unpaid_invoices) {
                            UserService.logoutAndRedirect("login", {
                                unpaid_invoices: $stateParams.unpaid_invoices
                            });
                        }
                    }
                }
            });
        }
        return user;
    };

    /**
     *  If the user hit /registration/ while he is already connected, we redirect it.
     *    This happens when user click on invitation link to register even if he already registered
     *     or writing it down directly.
     **/
    this.checkForAutoRedirectPage = function() {
        if (UserService.isLoggedIn()) {
            var unregister = $rootScope.$on("UserUpdated", function(event, user) {
                unregister();

                if (user.customer && $stateParams.retailer == user.customer.id) {
                    if ($stateParams.stocks) {
                        // TODO: WEG-938: some scenario doesn't work for the redirection
                        $state.go("stocks", {vendorId: $stateParams.stocks, catalog: $stateParams.catalog});
                    }
                    else if ($stateParams.vendor) {
                        $state.go("stocks", {vendorId: $stateParams.vendor});
                    }
                    else if ($stateParams.product) {
                        $state.go("stocks", {product: $stateParams.product});
                    }
                    else if ($stateParams.invoice) {
                        $state.go("invoiceDetails", {id: $stateParams.invoice});
                    }
                    else if ($stateParams.payment) {
                        $state.go("paymentDetails", {id: $stateParams.payment});
                    }
                    else if ($stateParams.unpaid_invoices) {
                        $state.go("payment", {selected: $stateParams.unpaid_invoices});
                    }
                    else {
                        $state.go("home");
                    }
                }
                else {
                    UserService.logout();
                }
            });
        }
    };

    this.fillDepartmentsWithVendorInviteToken = function(vendorInvite) {
        return $http({
            method: "GET",
            url: appConfig.API_SERVER + "/auth/vendor/departments/",
            params: {
                token: vendorInvite
            }
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/auth/registration.service.js
// module id = 895
// module chunks = 0